<script setup lang="ts">
import { type Pratica } from "@gasparigit/omnia-sdk";
import type { CreateLinkConfig } from "~/utils/types";

defineProps<{
  content: Pratica;
  compact?: boolean;
  showAreas?: boolean;
  showChildren?: boolean;
  linkConfig?: CreateLinkConfig;
}>();
</script>

<template>
  <FrontContentItemsBaseContent v-bind="$props">
    <template #preview>
      <IconsDocument class="flex-none text-primary w-12 h-12 mb-2"></IconsDocument>
    </template>
    <template #info>
      <p class="info-number mt-2 md:mt-0">Pratica Cod. {{ content.code }}</p>
    </template>
    <template #footer>
      <div v-if="showChildren && content.modelli?.length" class="text-base bg-primary-50 p-3 mt-3">
        <div class="flex flex-col gap-y-3 divide-y">
          <template v-for="modello in content.modelli" :key="`pratica-${content.id}-modello-${modello.id}`">
            <FrontContentItemsModello v-if="modello.code" :link-config="linkConfig" :content="modello" />
            <span v-else class="font-bold text-lg pt-3">{{ modello.title }}</span>
          </template>
        </div>
      </div>
    </template>
  </FrontContentItemsBaseContent>
</template>
